var map = {
	"./bg.webp": 38346,
	"./chess.webp": 94624,
	"./chess/01.webp": 35316,
	"./chess/02.webp": 94855,
	"./chess/03.webp": 15236,
	"./chess/04.webp": 5781,
	"./chess/bg.webp": 4792,
	"./chess/game/01.webp": 61208,
	"./chess/game/02.webp": 79461,
	"./chess/game/03.webp": 93815,
	"./chess/game/04.webp": 89750,
	"./chess/game/05.webp": 9097,
	"./chess/game/06.webp": 45912,
	"./chess/game/07.webp": 39983,
	"./chess/game/08.webp": 7226,
	"./chess/game/game01.webp": 72989,
	"./chess/game/game02.webp": 87118,
	"./chess/game/game03.webp": 13561,
	"./chess/game/game04.webp": 13977,
	"./chess/game/game05.webp": 38743,
	"./chess/game/game06.webp": 17018,
	"./chess/game/game07.webp": 2162,
	"./chess/menus01.webp": 68618,
	"./chess/menus02.webp": 83811,
	"./chess/menus03.webp": 95002,
	"./chess/title.webp": 16443,
	"./egame-money.webp": 58665,
	"./egame.webp": 60222,
	"./egame/01.webp": 47936,
	"./egame/02.webp": 20244,
	"./egame/bg.webp": 50517,
	"./egame/menus01.webp": 54170,
	"./egame/menus02.webp": 22196,
	"./egame/menus03.webp": 72162,
	"./egame/title.webp": 97221,
	"./egame/web-bg.webp": 9561,
	"./fishing.webp": 34102,
	"./fishing/01.webp": 72171,
	"./fishing/02.webp": 53662,
	"./fishing/03.webp": 27968,
	"./fishing/04.webp": 31447,
	"./fishing/bg.webp": 39083,
	"./fishing/menus01.webp": 67126,
	"./fishing/menus02.webp": 87887,
	"./fishing/menus03.webp": 65634,
	"./fishing/title.webp": 25226,
	"./gaming.webp": 44212,
	"./gaming/01.webp": 96070,
	"./gaming/02.webp": 97318,
	"./gaming/03.webp": 87746,
	"./gaming/game/01.webp": 19052,
	"./gaming/game/02.webp": 34894,
	"./gaming/game/03.webp": 89090,
	"./gaming/game/04.webp": 97662,
	"./gaming/game/05.webp": 86309,
	"./gaming/game/06.webp": 47761,
	"./gaming/game/07.webp": 6766,
	"./gaming/game/game01.webp": 33786,
	"./gaming/game/game02.webp": 50218,
	"./gaming/game/game03.webp": 36790,
	"./gaming/game/game04.webp": 11153,
	"./gaming/game/game05.webp": 78671,
	"./gaming/game/webbg.webp": 48996,
	"./gaming/menus01.webp": 91387,
	"./gaming/menus02.webp": 64875,
	"./gaming/menus03.webp": 89890,
	"./gaming/title.webp": 32660,
	"./hotsMenus.webp": 63055,
	"./icon01.webp": 34072,
	"./icon02.webp": 41334,
	"./icon03.webp": 65401,
	"./icon04.webp": 41751,
	"./lottery.webp": 84090,
	"./lottery/01.webp": 60242,
	"./lottery/02.webp": 27621,
	"./lottery/03.webp": 30521,
	"./lottery/04.webp": 32159,
	"./lottery/05.webp": 50872,
	"./lottery/06.webp": 503,
	"./lottery/07-1.webp": 97889,
	"./lottery/07.webp": 5303,
	"./lottery/08-1.webp": 25371,
	"./lottery/08.webp": 31101,
	"./lottery/game/01.webp": 26155,
	"./lottery/game/02.webp": 39453,
	"./lottery/game/03.webp": 31845,
	"./lottery/game/04.webp": 83201,
	"./lottery/game/bg.webp": 4912,
	"./lottery/game/bg1.webp": 8596,
	"./lottery/game/game01.webp": 16463,
	"./lottery/game/game02.webp": 6852,
	"./lottery/game/game03.webp": 73128,
	"./lottery/game/game04.webp": 23725,
	"./lottery/game/game05.webp": 84335,
	"./lottery/game/game06.webp": 63274,
	"./lottery/game/game07.webp": 51897,
	"./lottery/menus01.webp": 68529,
	"./lottery/menus02.webp": 50365,
	"./lottery/menus03.webp": 98157,
	"./lottery/title.webp": 65615,
	"./parther01.webp": 6950,
	"./partner01.webp": 50196,
	"./partner02.webp": 75847,
	"./realbet.webp": 27662,
	"./realbet/01.webp": 76881,
	"./realbet/02.webp": 12329,
	"./realbet/03.webp": 93509,
	"./realbet/game/01.webp": 37120,
	"./realbet/game/02.webp": 46009,
	"./realbet/game/03.webp": 73839,
	"./realbet/game/04.webp": 22932,
	"./realbet/game/05.webp": 99988,
	"./realbet/game/06.webp": 59830,
	"./realbet/game/07.webp": 68865,
	"./realbet/game/game01.webp": 88516,
	"./realbet/game/game02.webp": 5833,
	"./realbet/game/game03.webp": 42859,
	"./realbet/menus01.webp": 64182,
	"./realbet/menus02.webp": 28165,
	"./realbet/menus03.webp": 24561,
	"./realbet/title.webp": 63738,
	"./service03.webp": 8345,
	"./servicebg.webp": 7195,
	"./sport.webp": 99738,
	"./sport/01.webp": 45189,
	"./sport/02.webp": 58849,
	"./sport/03.webp": 37060,
	"./sport/04.webp": 92442,
	"./sport/05.webp": 70330,
	"./sport/06.webp": 94717,
	"./sport/07.webp": 36664,
	"./sport/bg.webp": 42034,
	"./sport/game/01.webp": 80741,
	"./sport/game/02.webp": 7610,
	"./sport/game/03.webp": 27080,
	"./sport/game/04.webp": 80670,
	"./sport/game/05.webp": 94399,
	"./sport/game/06.webp": 585,
	"./sport/game/07.webp": 79241,
	"./sport/game/08.webp": 86733,
	"./sport/game/09.webp": 33910,
	"./sport/game/10.webp": 21958,
	"./sport/game/bg.webp": 62957,
	"./sport/game/game01.webp": 53427,
	"./sport/game/game02.webp": 69010,
	"./sport/game/game03.webp": 31459,
	"./sport/menus01.webp": 65336,
	"./sport/menus02.webp": 52387,
	"./sport/menus03.webp": 30243,
	"./sport/title.webp": 11110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78790;